export default __webpack_public_path__ + "static/media/Kanit-ExtraBold.96baf422.ttf";